import { buildListingMarker } from '@components/_shared/googleMaps/mapUtils';
import { GoogleMaps } from '@components/_shared/googleMaps';
import { BaseComponentProps } from '@utils/types/baseComponents';
import { LatLng } from '@utils/types/locations';
import { MarkerType } from '@utils/types/maps';
import clsx from 'clsx';
import React from 'react';
import styles from './styles.module.scss';

type Props = {
  markers: MarkerType[];
  center: LatLng;
  zoom: number;
} & BaseComponentProps;

Map.defaultProps = {
  markers: [],
  center: { lat: 0, lng: 0 },
  zoom: 5,
};

export function Map(props: Props) {
  const { containerStyle, markers, center, zoom } = props;

  return (
    <div className={clsx([styles.mapContainer, containerStyle])}>
      <GoogleMaps
        center={center}
        zoom={zoom}
        markers={markers}
        buildMarker={buildListingMarker}
      />
    </div>
  );
}
